export const definedApiMethods = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE",
  any: "ANY",
};

export const ApiGateWayEndPoint = process.env.REACT_APP_GATEWAY;
export const TISPApiProbesEndpoint = process.env.REACT_APP_API_PROBE_GATEWAY;
export const CustomerSatisfactionEndpoint =
  process.env.REACT_APP_CUSTOMER_SATISFACTION_GATEWAY;
export const SsoEndpoint = `${process.env.REACT_APP_GATEWAY}/sso`;

export const definedRouteTypes = {
  login: "login",
  find: "find",
  maintenances: "maintenances",
  tisp_maintenances: "tisp_maintenances",
  tisp_query: "tisp_query",
  logbook: "logbook",
  file: "file",
  query: "query",
  webprobe: "webprobe",
  delete: "delete",
  version: "version",
  trace: "traces",
  admin: "admin",
  forecast: "forecast",
  contracts: "contracts",
  customer_satisfaction: "",
  api_probes: "api-probes",
  redshift: "redshift",
  on_call: "on_call",
  nce_changes: "change-management",
};

export const definedTracesResources = {
  request: "request",
  request_query: "request/query",
  query: "query",
  status: "status",
  config: "config",
};

export const definedLogbookResources = {
  import: "import",
  multiple: "multiple",
};

export const definedRedshiftResources = {
  customers: "customers",
};

export const definedForecastResources = {
  import: "import",
  post: "post",
  post_batch: "post_batch",
};

export const definedOnCallResources = {
  post: "post",
  query: "query",
};

export const definedCustomerSatisfactionResources = {
  save_template: "save-template",
  load_templates: "load-templates",
  post_batch: "post_batch",
};

export const definedLogbookImportResources = {
  jira: "jira",
  marketing: "marketing",
};

export const definedMaintenanceResources = {
  kpi: "kpi",
};

export const definedKpiResources = {
  status: "status",
  run: "run",
};

export const definedLoginResources = {
  sso: "sso",
  verify: "verify",
};

export const definedWebProbeResources = {
  entry: "entry",
  config: "config",
};

export const definedContractResources = {
  import: "import",
};

export const definedApiProbeResources = {
  handle_tests: "handle-tests",
  get_results: "get-results",
};

const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const date_fields = [
  "maintenance_starttime",
  "maintenance_endtime",
  "start-time-cetcest",
  "end-time-cetcest",
];

const maintenance_date_fields = [
  "maintenance_starttime",
  "maintenance_endtime",
];

const iso_force_adjuster = (number, addOne) => {
  let add = addOne ? number + 1 : number;
  const new_number = add < 10 ? `0${add}` : add;
  return new_number;
};

export const date_formatter = (
  date,
  drop_seconds = false,
  remove_t_z = false
) => {
  if (date && date instanceof Date) {
    const new_date = date;
    const year = new_date.getFullYear();
    const month = iso_force_adjuster(new_date.getMonth(), true);
    const day = iso_force_adjuster(new_date.getDate());
    const hour = iso_force_adjuster(new_date.getHours());
    const minutes = iso_force_adjuster(new_date.getMinutes());
    let seconds = iso_force_adjuster(new_date.getSeconds());
    if (drop_seconds) seconds = "00";
    let formatted_date = `${year}-${month}-${day}T${hour}:${minutes}:${seconds}.000Z`;
    if (remove_t_z) {
      formatted_date = `${year}-${month}-${day} ${hour}:${minutes}:${seconds}.000`;
    }
    return formatted_date;
  } else if (typeof date === "string") {
    return date_formatter(new Date(date), drop_seconds, remove_t_z);
  } else {
    return null;
  }
};

// currently forcing all dates to be passed to back-end be treated as UTC
// this should be moved to lambda normalizers at one point
const date_adjust_object = (body) => {
  const new_body = {};
  if (typeof body === "string") return body;
  Object.keys(body).forEach((k) => {
    let value = body[k];
    if (date_fields.includes(k)) {
      value = date_formatter(body[k]);
      if (maintenance_date_fields.includes(k)) {
        value = date_formatter(body[k], false, true);
      }
    }
    new_body[k] = value;
  });
  return new_body;
};

const date_field_adjuster = (body) => {
  let new_body = {};
  Object.keys(body).forEach((k) => {
    let value = body[k];
    if (!value) return;
    if (Array.isArray(value)) {
      value = value.map((el) => date_adjust_object(el));
    } else {
      if (value instanceof Date) {
        value = date_formatter(value);
      } else if (typeof value === "object") {
        value = date_adjust_object(value);
      }
    }
    new_body[k] = value;
  });

  return new_body;
};

export const ApiSettingsMaker = (method, body) => {
  const settings = {
    method,
    headers: {
      ...defaultHeaders,
      Authorization: sessionStorage.getItem("token"),
      user: sessionStorage.getItem("user"),
    },
  };
  if (body) {
    settings["body"] = JSON.stringify({
      ...date_field_adjuster(body),
      user: sessionStorage.getItem("user"),
    });
  }
  return settings;
};

export const GetSettings = {
  method: "GET",
};
